import React, {FC} from 'react';

import {TeammateOnlineStatusesEnum} from '../../../store/data/teammates/onlineTeammatesSelectors';
import {AvatarBadgeStatus, AvatarBadgeStatusProps} from './avatarBadgeStatus';
import {TeammateAvatar, TeammateAvatarProps} from './teammateAvatar';

/*
 * Props.
 */

type TeammateAvatarWithStatusProps = TeammateAvatarProps & AvatarBadgeStatusProps;

/*
 * Component.
 */

/** Display the avatar of the specified {@link ITeammate} with its status. */
export const TeammateAvatarWithStatus: FC<TeammateAvatarWithStatusProps> = (props) => {
  const hasBadge = props.onlineStatus !== TeammateOnlineStatusesEnum.UNKNOWN || props.color;
  return <TeammateAvatar {...props}>{hasBadge && <AvatarBadgeStatus {...props} />}</TeammateAvatar>;
};
